import React from 'react';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { CmsEntities } from 'client/data/models/cms';
import { Link } from 'site-modules/shared/components/link/link';

import './editor-card.scss';

export function EditorCard({ editor }) {
  const { title, summary } = editor;
  const {
    aboutLink,
    instagramLink,
    twitterLink,
    linkedInLink,
    youtubeLink,
    facebookLink,
    emailLink,
    position,
    photoLink,
  } = editor.getAllMetadata();

  const socialLinks = [
    { icon: 'icon-instagram', iconTitle: 'Instagram', link: instagramLink },
    { icon: 'icon-x', iconTitle: 'X', link: twitterLink },
    { icon: 'icon-linkedin', iconTitle: 'LinkedIn', link: linkedInLink },
    { icon: 'icon-play', iconTitle: 'YouTube', link: youtubeLink },
    { icon: 'icon-facebook2', iconTitle: 'Facebook', link: facebookLink },
    { icon: 'icon-envelop', iconTitle: 'Email', link: emailLink ? `mailto:${emailLink}` : null },
  ].filter(({ link }) => link);

  return (
    <Row tag="section" className="editor-card pos-r mb-2">
      <Col xs={12} lg={4} className="px-1 mb-1_5">
        <img src={photoLink} alt={title} className="w-100" />
      </Col>
      <Col xs={12} lg={8} className="size-16 px-1">
        <h3 className="size-20 mb-0">
          {aboutLink ? (
            <Link to={aboutLink} className="about-link text-cool-gray-10">
              {title}
            </Link>
          ) : (
            title
          )}
        </h3>
        <p className="mb-0_5">{position}</p>
        <p>{summary}</p>
        <div className="d-flex">
          {socialLinks.map(({ iconTitle, icon, link }) => (
            <Link
              key={icon}
              to={link}
              title={`${title}'s ${iconTitle}`}
              aria-label={`${title}'s ${iconTitle}`}
              className="social-link me-1"
            >
              <span className={`${icon} size-20 text-cool-gray-30`} aria-hidden />
            </Link>
          ))}
        </div>
      </Col>
    </Row>
  );
}

EditorCard.propTypes = {
  editor: CmsEntities.Content.isRequired,
};
